module.exports = __webpack_public_path__ + "static/media/favourite-guest.fdbc0a9f.png";